import { EmptyState } from '../../shared/ui';
import { PageHeader } from '../AdminShell';

/** Placeholder. The layout is real; the surface is not built yet. */
export default function AdminAnnouncements() {
  return (
    <>
      <PageHeader title="Announcements" description="Messages sent to learners on this academy." />
      <EmptyState title="Not built yet" body="Announcements will be composed here." />
    </>
  );
}
